// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-management-objects-ObjectsManager-module__box--H2QJ2 {
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
.src-pages-management-objects-ObjectsManager-module__content--S2jT9 {
  flex: 1;
  overflow: auto;
}
/*# sourceMappingURL=ObjectsManager.module.css.map */`, "",{"version":3,"sources":["webpack://./ObjectsManager.module.less","webpack://./src/pages/management/objects/ObjectsManager.module.less"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,gBAAA;EAEA,aAAA;EACA,sBAAA;ACAF;ADEA;EACE,OAAA;EACA,cAAA;ACAF;AACA,oDAAoD","sourcesContent":[".box {\n  height: 100%;\n  overflow: hidden;\n\n  display: flex;\n  flex-direction: column;\n}\n.content {\n  flex: 1;\n  overflow: auto;\n}\n",".box {\n  height: 100%;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n.content {\n  flex: 1;\n  overflow: auto;\n}\n/*# sourceMappingURL=ObjectsManager.module.css.map */"],"sourceRoot":""}]);
// Exports
export var box = `src-pages-management-objects-ObjectsManager-module__box--H2QJ2`;
export var content = `src-pages-management-objects-ObjectsManager-module__content--S2jT9`;
export default ___CSS_LOADER_EXPORT___;
